var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-class"},[_c('p',[_c('b',[_vm._v("404.")]),_c('ins',[_vm._v(_vm._s(_vm.$t("404Vue.msgHead")))])]),_c('p',[_vm._v(_vm._s(_vm.$t("404Vue.msgDesc"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }